import React, { FC } from 'react';
import { googleClickCtaEvent } from '../../../../../../utils/analytics';
import Icon from '../../../../../@shared/icon';
import RoutableSitecoreLink from '../../../../../@shared/routableSitecoreLink';

const MobileLogin: FC<{ fields: any }> = ({ fields }) => {
  return (
    <li className="navigation__utility__item">
      <RoutableSitecoreLink
        field={fields?.login?.link}
        target={'_blank'}
        onClick={(): void => {
          googleClickCtaEvent(
            'Global Nav',
            fields?.login?.link?.value?.text,
            fields?.login?.link?.value?.text
          );
        }}
        className="navigation__utility__link"
      >
        <Icon iconField={fields.login?.icon} extraClassName="navigation__utility__icon" size={24} />
        <span className="navigation__utility__text">{fields?.login?.link?.value?.text}</span>
      </RoutableSitecoreLink>
    </li>
  );
};

export default MobileLogin;
